"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const communicationSlice_1 = require("../communicationSlice");
const callConnecting_1 = __importDefault(require("./callConnecting/callConnecting"));
const callFailed_1 = __importDefault(require("./callFailed/callFailed"));
const callEnded_1 = __importDefault(require("./callEnded/callEnded"));
const callConfirmed_1 = __importDefault(require("./callConfirmed/callConfirmed"));
const typesConstants_1 = require("../../../constants/typesConstants");
const boxTitle_1 = __importDefault(require("../../boxTitle/boxTitle"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const communicationBoxConstants_1 = require("../communicationBoxConstants");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const expandableBox_1 = __importDefault(require("../../expandableBox/expandableBox"));
const callFeedback_1 = __importDefault(require("../callFeedback/callFeedback"));
const actionsLoadingComponent_1 = __importDefault(require("../../actionsLoadingComponent/actionsLoadingComponent"));
const utils_1 = require("../../../utils/utils");
const goBackComponent_1 = __importDefault(require("../baseContent/goBackComponent"));
const spinner_1 = __importDefault(require("../../spinner/spinner"));
const analytics_1 = require("../../../utils/analytics");
const eventConstants_1 = require("../../../constants/eventConstants");
const sendSMS_1 = __importDefault(require("../sendSMS/sendSMS"));
const callConstant_1 = require("../../../features/call/callConstant");
const DefaultProps = {
    sms: false,
    feedback: false,
};
const VoipCall = ({ voipCallProvider, userPhoneNumber, selectedContact, setBaseContent, sms, feedback, scheduleId, }) => {
    const dispatch = useAppDispatch_1.default();
    const [session, setSession] = react_1.useState(null);
    const remoteAudio = react_1.useRef(null); // nosemgrep: typescript.react.security.audit.react-no-refs.react-no-refs
    // prettier-ignore
    const audioComponent = (react_1.default.createElement("audio", { ref: remoteAudio },
        react_1.default.createElement("track", { kind: "captions", label: userPhoneNumber }))); // nosemgrep: typescript.react.security.audit.react-no-refs.react-no-refs
    const [startDatetime, setStartDatetime] = react_1.useState(null);
    const [endDatetime, setEndDatetime] = react_1.useState(null);
    const [callFailedMessage, setCallFailedMessage] = react_1.useState('');
    const [sipData, setSipData] = react_1.useState(null);
    const [isMutedState, setIsMutedState] = react_1.useState(false);
    const [isOnHold, setIsOnHold] = react_1.useState(false);
    const [connectVoipServer, setConnectVoipServer] = react_1.useState(true);
    const { ua, voipUserId, voipPassword, callStatus, officerType, selectedCallerID } = useAppSelector_1.default((state) => ({
        ua: state.communication.ua,
        voipUserId: state.auth.user.voip_user_id,
        voipPassword: state.auth.user.voip_password,
        callStatus: state.communication.voipCallStatus,
        officerType: state.auth.user.officer_type,
        selectedCallerID: state.communication.selectedCallerID,
    }));
    const disableButton = callStatus === communicationBoxConstants_1.CONNECTING || callStatus === communicationBoxConstants_1.CONFIRMED;
    // If no caller ID is selected, use the default in asterisk.
    const callerID = selectedCallerID ? selectedCallerID.number : '';
    // Get and set the officer asterisk call extension.
    const prefix = callConstant_1.EXTENSIONS.get(officerType) || callConstant_1.CREDIT_COLLECTIONS;
    // Operation officers use manual calls only, so we can set a Caller ID instead of a schedule ID.
    const suffix = officerType === typesConstants_1.OFFICER_TYPES_OPERATIONS ? callerID : scheduleId;
    const callContext = `${prefix}#${userPhoneNumber}#${voipCallProvider.asterisk_value}#${suffix}`;
    react_1.useEffect(() => {
        // Create a new websocket connection on mount
        dispatch(communicationSlice_1.newUAConnection({ voipUserId, voipPassword }));
    }, []);
    const setCallStatus = (status) => {
        dispatch(communicationSlice_1.updateCallStatus({ status }));
    };
    const muteCallHandler = (isMuted) => {
        const action = isMuted ? 'mute' : 'unmute';
        session[action](); // nosemgrep: javascript.lang.security.audit.unsafe-dynamic-method.unsafe-dynamic-method
        setIsMutedState(isMuted);
    };
    const holdCallHandler = (isHold) => {
        const action = isHold ? 'hold' : 'unhold';
        const success = session[action](); // nosemgrep: javascript.lang.security.audit.unsafe-dynamic-method.unsafe-dynamic-method
        if (success) {
            const actionPlay = isHold ? 'pause' : 'play';
            remoteAudio.current[actionPlay](); // nosemgrep: javascript.lang.security.audit.unsafe-dynamic-method.unsafe-dynamic-method
            setIsOnHold(isHold);
        }
    };
    const endCallHandler = () => {
        ua.terminateSessions();
    };
    const closeVoipConnection = () => {
        // End current voip websocket connection
        ua.stop();
        if (connectVoipServer) {
            // Prevent creating a new connection on call disconnection.
            setConnectVoipServer(false);
        }
        // set a new connection in state
        dispatch(communicationSlice_1.newUAConnection({ voipUserId, voipPassword }));
    };
    const startUAConnection = () => {
        ua.start();
        ua.on('connected', () => {
            analytics_1.logEvent(eventConstants_1.UA_CONNECTED);
            const options = {
                eventHandlers: {
                    progress() {
                        analytics_1.logEvent(eventConstants_1.CONNECTING_HANDLER);
                        setCallStatus(communicationBoxConstants_1.CONNECTING);
                    },
                    failed(e) {
                        analytics_1.logEvent(eventConstants_1.FAILED_HANDLER);
                        setCallStatus(communicationBoxConstants_1.FAILED);
                        setSipData(e.message);
                        setCallFailedMessage(e.cause);
                        closeVoipConnection();
                    },
                    ended() {
                        analytics_1.logEvent(eventConstants_1.ENDED_HANDLER);
                        setEndDatetime(new Date());
                        setCallStatus(communicationBoxConstants_1.ENDED);
                        closeVoipConnection();
                    },
                    confirmed() {
                        analytics_1.logEvent(eventConstants_1.CONFIRMED_HANDLER);
                        setStartDatetime(new Date());
                        setCallStatus(communicationBoxConstants_1.CONFIRMED);
                    },
                },
                ...communicationBoxConstants_1.MEDIA_CONSTRAINTS,
            };
            setSession(ua.call(callContext, options));
        });
        ua.on('disconnected', (e) => {
            setSipData({ status_code: e.code });
            analytics_1.logEvent(eventConstants_1.UA_DISCONNECTED);
            // Only display disconnect error page, if the disconnection is as a result of an error.
            if (e.error) {
                setCallStatus(communicationBoxConstants_1.DISCONNECTED);
                closeVoipConnection();
            }
        });
        ua.on('registered', (e) => {
            setSipData(e.response);
        });
    };
    if (ua && connectVoipServer) {
        startUAConnection();
    }
    const redialHandler = () => {
        setCallStatus(communicationBoxConstants_1.IDLE);
        startUAConnection();
    };
    if (session) {
        session.connection.addEventListener('track', (e) => {
            analytics_1.logEvent(eventConstants_1.SET_TRACK_STREAM);
            // set remote audio stream
            const { 0: stream } = e.streams;
            if (remoteAudio.current === null) {
                return;
            }
            remoteAudio.current.srcObject = stream;
            remoteAudio.current.addEventListener('canplay', () => {
                remoteAudio.current.play();
            });
        });
    }
    let content;
    if (callStatus === communicationBoxConstants_1.CONNECTING) {
        content = react_1.default.createElement(callConnecting_1.default, { endCall: endCallHandler });
    }
    else if (callStatus === communicationBoxConstants_1.FAILED) {
        content = react_1.default.createElement(callFailed_1.default, { redialHandler: redialHandler, callFailedMessage: callFailedMessage });
    }
    else if (callStatus === communicationBoxConstants_1.ENDED) {
        content = react_1.default.createElement(callEnded_1.default, { duration: utils_1.getTimeUsed(startDatetime, endDatetime), redialHandler: redialHandler });
    }
    else if (callStatus === communicationBoxConstants_1.CONFIRMED) {
        content = (react_1.default.createElement(callConfirmed_1.default, { isMuted: isMutedState, isOnHold: isOnHold, muteCallHandler: muteCallHandler, holdCallHandler: holdCallHandler, contact: selectedContact.phone_number, endCall: endCallHandler, startDatetime: startDatetime }));
    }
    else if (callStatus === communicationBoxConstants_1.DISCONNECTED) {
        content = (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                react_1.default.createElement(boxTitle_1.default, { title: "ERROR: Can\u2019t establish a connection to the server" }))));
    }
    else if (callStatus === communicationBoxConstants_1.IDLE) {
        content = react_1.default.createElement(spinner_1.default, null);
    }
    const sendSMSComponent = (react_1.default.createElement(sendSMS_1.default, { showTitle: false, scheduleId: scheduleId, selectedContact: selectedContact, setBaseContent: null, withMinHeight: false }));
    const expandedComponent = (react_1.default.createElement(react_1.default.Fragment, null,
        content,
        sms && (react_1.default.createElement(expandableBox_1.default, { withMinHeight: false, title: `Send ${selectedContact.first_name} an SMS.`, expandedComponent: sendSMSComponent, baseComponent: null, eventName: eventConstants_1.SEND_SMS_EXPAND_PRESS })),
        feedback && (react_1.default.createElement(actionsLoadingComponent_1.default, { actionType: typesConstants_1.LOG_CALL_ACTION_TYPE },
            react_1.default.createElement(callFeedback_1.default, { setBaseContent: setBaseContent, selectedContact: selectedContact, callType: communicationBoxConstants_1.CALL_TYPE_VOIP, duration: startDatetime && endDatetime ? utils_1.getTimeUsed(startDatetime, endDatetime) : '00:00:00', provider: voipCallProvider, sipData: sipData, disableSaveButton: disableButton })))));
    const baseComponent = (react_1.default.createElement(react_1.default.Fragment, null,
        content,
        react_1.default.createElement(goBackComponent_1.default, { onPress: setBaseContent, disabled: disableButton })));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        audioComponent,
        react_1.default.createElement(expandableBox_1.default, { expandedOnFirstView: true, title: `${selectedContact.first_name} ${selectedContact.last_name}`, baseComponent: baseComponent, expandedComponent: expandedComponent, eventName: eventConstants_1.VOIP_CALL_EXPAND_PRESS })));
};
VoipCall.defaultProps = DefaultProps;
exports.default = VoipCall;
